export const ProfilePictureAvatar = ({
  profilePicture,
  fullName,
  isOnline,
  size = 30,
}: {
  profilePicture: string | null;
  fullName: string | null;
  isOnline?: boolean | null;
  size?: number;
}) => {
  const statusSize = (size * 14) / 30;
  return (
    <div
      style={{
        position: "relative",
        display: "inline-block",
        marginRight: "10px",
      }}
    >
      <img
        src={profilePicture ?? `https://ui-avatars.com/api/?name=${fullName}`}
        alt=""
        width={size}
        height={size}
        style={{ borderRadius: "100%" }}
        className="object-fit-cover"
      />
      {isOnline !== undefined && (
        <span
          style={{
            position: "absolute",
            bottom: -statusSize / 6,
            right: -statusSize / 6,
            width: statusSize,
            height: statusSize,
            backgroundColor: isOnline ? "#43a25a" : "#d83a42",
            borderRadius: "50%",
            border: `${statusSize / 6}px solid white`,
          }}
        />
      )}
    </div>
  );
};
